<template>
  <b-modal
    v-model="modalShow"
    v-bind="$attrs"
    :modal-class="`${isWinType && 'isWinType'} ${isFullScreen && 'isFullScreen'} ${modalClass}`"
    centered
    hide-footer
    hide-header
    lazy
    @hide="handleModalVisibility"
  >
    <div slot="modal-title">
      <slot name="header" />
    </div>
    <div
      v-if="isBackButtonEnabled"
      :class="[
        'px-3 py-2',
        isBackButtonSticky && $style.backButtonStickyWrapper
      ]"
    >
      <font-awesome-icon
        :class="$style.backIcon"
        icon="arrow-left"
        size="lg"
        @click="modalShow = false"
      />
    </div>
    <slot name="body" />
    <div
      slot="modal-footer"
      class="w-100"
    >
      <slot name="footer" />
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'Modal',
  inheritAttrs: false,
  props: {
    modalClass: {
      type: String,
      default: '',
    },
    isBackButtonEnabled: {
      type: Boolean,
      default: true,
    },
    isBackButtonSticky: {
      type: Boolean,
      default: false,
    },
    isWinType: {
      type: Boolean,
      default: false,
    },
    isFullScreen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalShow: true,
    }
  },
  watch: {
    modalShow() {
      this.$emit('close')
    },
  },
  methods: {
    handleModalVisibility(e) {
      e.preventDefault()
      this.modalShow = false
    },
  },
}
</script>

<style lang="scss">
  @import '~bootstrap/scss/bootstrap';
  @import "../../assets/scss/variables";

  @include media-breakpoint-down(xs) {
    .modal-dialog {
      height: 100vh;
      width: 100vw;
      margin: 0 !important;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow-x: hidden;
      .modal-content {
        border: none;
        border-radius: 0;
        overflow-y: auto;
        height: 100vh;
        background: $color-midnight-blue url('../../assets/images/modal_bg.jpg') top;
        background-size: cover;
        color: $color-white;
        .modal-body {
          display: flex;
          flex-direction: column;
          padding: 0;
          h1, h2 {
            color: $color-white;
          }
        }
        hr {
          border-color: $color-violet-verbena;
        }
      }
    }
  }

  .isWinType {
    .modal-dialog {
      .modal-content {
        border: 3px solid $color-tomato;
        background: $color-midnight-blue url('../../assets/images/modal_bg.jpg') top;
        background-size: cover;
        color: $color-white;
      }
    }
  }

  .isFullScreen {
    .modal-dialog {
      width: 100vw;
      height: 100vh;
      margin: 0 !important;
      max-width: 100vw;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow-x: hidden;
      .modal-content {
        border: none;
        border-radius: 0;
        overflow-y: auto;
        height: 100vh;
        background: $color-midnight-blue url('../../assets/images/modal_bg.jpg') top;
        background-size: cover;
        color: $color-white;
        .modal-body {
          display: flex;
          flex-direction: column;
          padding: 5px;
        }
      }
    }
  }
</style>

<style lang="scss" module>
  .backButtonStickyWrapper {
    position: absolute;
    z-index: 5;
    top: 12px;
    left: 10px;
  }
  .backIcon {
    cursor: pointer;
    transition: all .3s ease-in-out;
    transform: scale(1.2);
    &:hover {
      transform: scale(1.5);
    }
  }
</style>
